import { render, staticRenderFns } from "./AnnouncementsIndex.vue?vue&type=template&id=32b47633&scoped=true"
import script from "./AnnouncementsIndex.vue?vue&type=script&lang=js"
export * from "./AnnouncementsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b47633",
  null
  
)

export default component.exports